// extracted by mini-css-extract-plugin
module.exports = {"container":"_3AjdB1MWUI4U6UnM3KPC2O","header":"_2GBb-ze1uXzXl5qlJf08W1","content":"_1WVjFlZGYxwVuRodakXQj8"};